import { memo, useEffect, useState } from "react"
import { useActions } from "../../../hooks/useActions"
import { useTypedSelector } from "../../../hooks/useTypedSelector"
import { Flex, Divider, Spin, Table, message } from "antd"
import useProjectDataColumns from "../hooks/UseProjectDataRanksColumns"
import { TableProps } from "antd"
import Filters from "./FIlters"
import dayjs from "dayjs"
import { IProjectDataRank } from "../types/projectDataRanks.types"
import { useSearchParams, useNavigate } from "react-router-dom"
import { routePath } from "../../../router/types"
import useMaxRows from "../../../hooks/useMaxRows"

const MemoTable = memo<TableProps<IProjectDataRank>>(Table)

const ProjectDataRanksConteiner: React.FC = () => {
  const [dateRange, setDateRange] = useState<{ startDate: string; endDate: string }>({
    startDate: dayjs().subtract(1, "month").format("YYYY-MM-DD"),
    endDate: dayjs().format("YYYY-MM-DD"),
  })
  const [asin, setAsin] = useState<string>("")

  const params = useSearchParams()[0]
  const projectId = params.get("projectId")

  const rowCount = useMaxRows({ offset: 260 })

  const { getProjectDataRanks } = useActions()
  const { projectDataRanks, loading, error } = useTypedSelector((state) => state.projectDataRanks)
  const { projectData } = useTypedSelector((state) => state.projectDataSettings)

  const navigate = useNavigate()
  useEffect(() => {
    if (!projectId) {
      navigate(routePath.PROJECTS)
      return
    }

    if (asin && dateRange.startDate && dateRange.endDate) {
      getProjectDataRanks({
        asin,
        startDate: dateRange.startDate,
        endDate: dateRange.endDate,
        projectId,
      })
    }
  }, [asin, dateRange.startDate, dateRange.endDate, projectId])

  useEffect(() => {
    if (error) {
      message.error(error)
    }
  }, [error])

  useEffect(() => {
    const primaryAsin =
      projectData.asins.find((asin) => asin.isPrimary)?.asin || projectData.asins[0]?.asin
    setAsin(primaryAsin)
  }, [projectData.asins])

  const columns = useProjectDataColumns(
    projectDataRanks?.length,
    dateRange.startDate,
    dateRange.endDate
  )

  return (
    <Flex vertical>
      <Filters setDateRange={setDateRange} dateRange={dateRange} setAsin={setAsin} asin={asin} />
      <Divider />
      {loading ? (
        <Spin />
      ) : (
        <MemoTable
          dataSource={projectDataRanks}
          columns={columns}
          scroll={{ x: "max-content" }}
          pagination={{
            pageSize: rowCount,
          }}
        />
      )}
    </Flex>
  )
}

export default ProjectDataRanksConteiner
